"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
function calculateBatchItem(item, order) {
    var _a;
    // 選擇 surcharge
    // 若 Order 有設定服務費優先使用，否則使用 merchant 的服務費設定
    let surchargeModifier = { percent: 0, amount: 0 };
    if (order.deliveryType === 'table') {
        surchargeModifier = (_a = lodash_1.default.find(order === null || order === void 0 ? void 0 : order.modifiers, ['type', 'SURCHARGE'])) !== null && _a !== void 0 ? _a : { percent: 0, amount: 0 };
    }
    // 計算 optionsTotal (sum by options price * quantity)
    const optionsTotal = lodash_1.default.sumBy(item.options, option => option.price * option.quantity);
    // 計算基本的價格 不含折扣和服務費
    let baseTotal = (item.price - item.discount + optionsTotal);
    // 整理 modifiers
    const modifiers = [...item.modifiers];
    // order.modifiers.forEach(modifier => {
    //   if (!item.excludeOrderDiscount || (modifier.overrideItem ?? false)) {
    //     modifiers.push(modifier)
    //   }
    // })
    if (order.deliveryType === 'table') {
        if (!item.excludedOrderSurcharge) {
            modifiers.push(surchargeModifier);
        }
    }
    // 計算 modifiers
    let totalDiscount = 0; // 統計全部折扣
    let totalSurcharge = 0; // 統計全部費用
    let total = modifiers.reduce((total, modifier) => {
        const newTotal = total * (100 + modifier.percent) / 100 + modifier.amount;
        const diffAmount = newTotal - total;
        if (diffAmount < 0) {
            // 折扣
            totalDiscount += Math.abs(diffAmount);
        }
        else {
            // 費用
            totalSurcharge += diffAmount;
        }
        return newTotal;
    }, baseTotal);
    const setItems = item.setItems.map((setItem) => calculateBatchItem(setItem, order));
    const setItemsDiscountTotal = lodash_1.default.sumBy(setItems, 'totalDiscount');
    const setItemsSurcharge = lodash_1.default.sumBy(setItems, 'surcharge');
    const setItemsTotal = lodash_1.default.sumBy(setItems, 'total');
    totalDiscount += setItemsDiscountTotal;
    totalSurcharge += setItemsSurcharge;
    total += setItemsTotal;
    // 計算 quantity
    const divisor = item.divisor != null && item.divisor !== 0 ? item.divisor : 1;
    totalDiscount *= item.quantity / divisor;
    totalSurcharge *= item.quantity / divisor;
    total *= item.quantity / divisor;
    baseTotal *= item.quantity / divisor;
    return Object.assign(Object.assign({}, item), { totalDiscount: totalDiscount, surcharge: totalSurcharge, total: item.cancelled ? 0 : total, originalTotal: item.cancelled ? 0 : (baseTotal + totalSurcharge), setItems });
}
exports.default = calculateBatchItem;
//# sourceMappingURL=calculateBatchItem.js.map